// fetchWrapper.js
/**
 * Wrapper para peticiones HTTP con fetch API.
 *
 * Gestiona automáticamente headers de autenticación, Content-Type y manejo de errores.
 * Detecta automáticamente peticiones de archivos y configura headers apropiados.
 *
 * @param {string} url - URL completa del endpoint
 * @param {Object|FormData} body - Cuerpo de la petición (JSON o FormData)
 * @param {string} method - Método HTTP (GET, POST, PUT, DELETE, etc.)
 * @returns {Promise<Response>} Respuesta del servidor
 * @throws {Error} Lanza error con mensaje del servidor si la petición falla
 */
const fetchWrapper = async (url, body = {}, method = "GET") => {
  const token = localStorage.getItem("token");
  const user = localStorage.getItem("user_id");

  const headers = {
    Authorization: `Bearer ${token}`,
    user: user,
    Accept: "application/json",
  };

  // Determinar si se trata de una petición de archivo
  // - Por URL: Endpoints conocidos que manejan archivos
  // - Por tipo: Si body es FormData, es una petición de archivo
  const isFileRequest =
    url.includes("/data_sources_file/upload_file") ||
    url.includes("/sources/upload_file") ||
    url.includes("/data_sources/edit/") ||
    url.includes("/cards/card_file/") ||
    url.includes("/export") ||
    body instanceof FormData ||
    url.includes("/user-equipment/register") ||
    (url.includes("/user-equipment/") && body instanceof FormData);

  // Solo agregar Content-Type si NO es petición de archivo
  // Para FormData, el navegador configura automáticamente multipart/form-data con boundary
  if (!isFileRequest) {
    headers["Content-Type"] = "application/json";
  }

  const config = {
    method,
    headers,
  };

  if (method !== "GET" && body !== undefined) {
    config.body = body;
  }

  const response = await fetch(url, config);

  if (!response.ok) {
    let errorMessage = "Ocurrió un error en la solicitud.";

    try {
      const errorData = await response.json();
      errorMessage = errorData.message || errorMessage;
    } catch (e) {
      // Si no se puede parsear JSON, usar mensaje genérico
    }

    // Si el error es 401 (No autorizado), muestra un alert y cierra la sesión
    if (response.status === 401) {
      handleLogout();
    }

    // Si el error es 403 (Sin permisos), mostrar mensaje específico
    if (response.status === 403) {
      errorMessage = errorMessage || "No tienes permisos para realizar esta acción";
    }

    throw new Error(errorMessage);
  }

  return response;
};

// Maneja las alertas de exito fallo
const handleLogout = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("user_id");
  localStorage.removeItem("permissions");
  window.location.href = "/auth/sign-in";
};

export default fetchWrapper;
